import { Controller } from "stimulus"
import * as Modal from "../src/javascripts/modal.js"
import {nextCartQuantity, normalizeCartQuantity, cartonCount} from "../src/javascripts/cart_quantity"
import {swissAmount} from '../src/javascripts/currency_format'
import {deliveryRecipient} from '../src/javascripts/delivery_recipient'

export default class extends Controller {

  static targets = [ "overlay", "cartMenuWrapper", "vat", "companyData", "privateData", "companyInvoiceData", "invoice_direction", "invoiceDirectionToggle", "invoice_direction_header", "shipping_address", "checkout_payment", "navbarCartItemsCounter", "navbarMobileCartItemsCounter", "cartMenuItems", "cartMenuCheckoutButton", "cartMenuSummary", "cartMenuShippingLabel", "cartMenuShippingCost", "cartMenuTotal", "checkoutCartItems", "checkoutItemList", "clearCartButton", "checkoutSummaryCartItems", "checkoutShipping", "checkoutPayment", "checkoutConfirmation", "checkoutCartNextButton", "checkoutCartFinishButton", "checkoutCartItemsCount", "checkoutShippingCost", "checkoutTotal", "checkoutVat", "checkoutItems", "vouchercode", "checkoutCharges", "checkoutChargesSummary", "signinModal", "itemPrice", "category_items_loading"]

  static values = {
    currencyFormat: String,
    currencyAbbr: String
  }

  initialize() {
    if(this.element.getAttribute("data-checkout-step")) {
      this.currentStep = parseInt(this.element.getAttribute("data-checkout-step"));
    } else {
      this.currentStep = 1;
    }

    this.locale = this.element.getAttribute("data-locale");
    this.country = this.element.getAttribute("data-country");
    if(!this.locale) {
      this.locale = document.querySelector("meta[name='locale']").getAttribute('content');
    }
    if(!this.country) {
      this.country = document.querySelector("meta[name='country']").getAttribute('content');
    }

    this.currency = document.querySelector("meta[name='currency']").getAttribute('content');
  }

  connect() {
    this.steps = 4;
    if(location.href.endsWith('checkout')) {
      let total = document.querySelector("input#checkout_total_with_vat").value;
      let currency = document.querySelector("input#checkout_currency").value;
      window.sendAnalytics('begin_checkout', {currency: currency, value: total});
    }

    if(this.hasCategory_items_loadingTarget) {
      let that = this;

      var observer = new IntersectionObserver(function(entries) {
      	if(entries[0].isIntersecting === true)
      		that.loadNextItems(entries[0].target.dataset.offset);
      }, { threshold: [0], rootMargin: "200px" });

      observer.observe(this.category_items_loadingTarget);
    }
  }

  async addWishlist(event) {
    event.preventDefault();
    const button = event.currentTarget;
    if (button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(button.dataset.url, {
        method: 'POST', credentials: 'same-origin',
        headers: {'Accept': 'application/json', 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content}
      });
      if (!response.ok) {
        let message = button.dataset.error;
        try { message = (await response.json()).error || message; } catch (_) {}
        throw new Error(message);
      }
      this.updateCart(await response.json());
      this.toggleCart();
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
    }
  }

  loadNextItems(offset) {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    searchParams.set('offset', offset);

    Rails.ajax({
      url: `${url.origin}${url.pathname}?${searchParams.toString()}`,
      type: "get",
      data: "",
      success: function(data) {},
      error: function(data) {}
    })

    this.category_items_loadingTarget.setAttribute('data-offset', parseInt(offset, 10) + (parseInt(this.category_items_loadingTarget.dataset.batchSize, 10) || 50));
  }

  currenciesFormat(value, currency) {
    if((currency || this.currency) === 'CHF') value = swissAmount(value);
    if(this.currencyFormatValue == '%u %n') {
      return `${this.currencyAbbrValue} ${value}`
    } else {
      return `${value} ${this.currencyAbbrValue}`
    }
  }

  removeTags(str) {
    if((str===null) || (str===''))
      return '';
    else
      str = str.toString();
    return str.replace( /(<([^>]+)>)/ig, '');
  }

  mainImage() {
    let parent = event.target.parentNode;
    if(parent.dataset.mainImg) {
      event.target.src = parent.dataset.mainImg;
      parent.removeAttribute('data-main-img');
    }
  }

  altImage() {
    let parent = event.target.parentNode;
    if(parent.dataset.altImg) {
      parent.setAttribute('data-main-img', event.target.src);
      event.target.src = parent.dataset.altImg;
    }
  }

  toggleCart() {
    this.cartMenuWrapperTarget.classList.toggle('active');
    this.overlayTarget.classList.toggle('active');

    if(this.cartMenuWrapperTarget.classList.contains("active")) {
      window.sendAnalytics('view_cart', {});
    }
  }

  toggleMobileMenu() {
    document.querySelector("#navbarMain").classList.toggle('is-active');
  }

  addToCart() {
    let that = this;
    let cartController = this;
    let uuid = event.target.dataset.uuid;
    let quantity = event.target.dataset.quantity;
    let product_number = event.target.dataset.product_number;
    let item = I18n.t('item.item');
    let inp;
    if(document.querySelector("h1.title")) {
      item = document.querySelector("h1.title").textContent;
    }

    let isM2Item = false;
    let m2Quantity = null;
    let pricePerM2 = null;

    const m2Input = document.querySelector('[data-items-target="m2Quantity"]');
    if(m2Input) {
      isM2Item = true;
      m2Quantity = parseFloat(m2Input.value);
      pricePerM2 = parseFloat(m2Input.dataset.pricePerM2);
      quantity = m2Quantity;
    } else if(!quantity) {
      let div = event.target.parentNode.parentNode.parentNode;
      inp = div.querySelector("input#item_quantity");
      if(inp) {
        quantity = inp.value;
      }
    }

    if(!quantity || !uuid) {
      event.stopPropagation();
      return
    }

    let json = {
      uuid: uuid,
      quantity: quantity
    }

    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/cart/add`,
      type: "post",
      data: JSON.stringify(json),
      contentType: false,
      processData: false,
      success: function(data) {
        that.updateCart(data);

        if(isM2Item) {
          const itemsController = that.application.getControllerForElementAndIdentifier(
            document.querySelector('[data-controller~="items"]'),
            'items'
          );

          if(itemsController && itemsController.showCartModal) {
            const imageElement = document.querySelector('[data-items-target="image"]');
            const vat = m2Input.dataset.vat;
            itemsController.showCartModal({
              name: item,
              sku: product_number,
              m2Quantity: m2Quantity,
              pricePerM2: pricePerM2,
              totalPrice: m2Quantity * pricePerM2,
              image: imageElement ? imageElement.src : null,
              vat: vat
            });
          }
        } else {
          let box = document.createElement("div")
          box.setAttribute("class", "box has-background-primary has-text-white")
          box.textContent = I18n.t('cart.messages.added_to_cart', {item: item})
          box.style.position = "absolute";
          box.style.top = "40vh";
          box.style.left = "50%";
          box.style.transform = "translate(-50%, -50%)"
          box.style.width = "600px";
          box.style.maxWidth = "90vw";
          document.querySelector("div.container").appendChild(box);
          main.fadeOut(box, 2000);

          if(inp) {
            inp.value = inp.getAttribute("min");
          }
        }

        let currency = document.querySelector('meta[name="currency"]').content;
        let price = 0;
        let p = that.itemPriceTarget;
        if(p) {
          price = p.dataset.price
        }

        window.sendAnalytics('add_to_cart', {currency: currency, value: price*quantity, items: [{'product' : product_number, 'quantity' : quantity}]});
      },
      error: function(xhr, textStatus, errorThrown) {
        let actualXhr = errorThrown;
        let response = xhr;

        if(actualXhr.status === 409 && response && response.error === 'insufficient_stock') {
          let box = document.createElement("div")
          box.setAttribute("class", "box has-background-danger has-text-white")
          box.textContent = I18n.t('cart.messages.insufficient_stock', {available: response.available, requested: response.requested}) || `Insufficient stock. Available: ${response.available}, Requested: ${response.requested}`;
          box.style.position = "absolute";
          box.style.top = "40vh";
          box.style.left = "50%";
          box.style.transform = "translate(-50%, -50%)"
          box.style.width = "600px";
          box.style.maxWidth = "90vw";
          box.style.zIndex = "9999";
          let container = document.querySelector("div.container");
          if(container) {
            container.appendChild(box);
            if(typeof main !== 'undefined' && main.fadeOut) {
              main.fadeOut(box, 4000);
            } else {
              setTimeout(() => box.remove(), 4000);
            }
          } else {
            document.body.appendChild(box);
            setTimeout(() => box.remove(), 4000);
          }
        }
      }
    });
    event.stopPropagation();
  }

  requestQuote() {
    let that = this;
    let uuid = event.target.dataset.uuid;
    let quantity = event.target.dataset.quantity;
    let product_number = event.target.dataset.product_number;
    let item = I18n.t('item.item');
    let inp;
    if(document.querySelector("h1.title")) {
      item = document.querySelector("h1.title").textContent;
    }

    let isM2Item = false;
    let m2Quantity = null;
    let pricePerM2 = null;

    const m2Input = document.querySelector('[data-items-target="m2Quantity"]');
    if(m2Input) {
      isM2Item = true;
      m2Quantity = parseFloat(m2Input.value);
      pricePerM2 = parseFloat(m2Input.dataset.pricePerM2);
      quantity = m2Quantity;
    } else if(!quantity) {
      let div = event.target.parentNode.parentNode.parentNode;
      inp = div.querySelector("input#item_quantity");
      if(inp) {
        quantity = inp.value;
      }
    }

    if(!quantity || !uuid) {
      event.stopPropagation();
      return
    }

    const country = this.country || 'en';
    const locale = this.locale || 'en';

    Rails.ajax({
      url: `/${country.toLowerCase()}-${locale}/cart/clear_for_quote`,
      type: "post",
      data: "",
      success: function(data) {
        let json = {
          uuid: uuid,
          quantity: quantity,
          quote_request: true
        }

        Rails.ajax({
          url: `/${country.toLowerCase()}-${locale}/cart/add`,
          type: "post",
          data: JSON.stringify(json),
          contentType: false,
          processData: false,
          success: function(data) {
            sessionStorage.setItem('quote_request', 'true');

            if(isM2Item) {
              const itemsController = that.application.getControllerForElementAndIdentifier(
                document.querySelector('[data-controller~="items"]'),
                'items'
              );

              if(itemsController && itemsController.showCartModal) {
                const imageElement = document.querySelector('[data-items-target="image"]');
                const vat = m2Input.dataset.vat;
                itemsController.showCartModal({
                  name: item,
                  sku: product_number,
                  m2Quantity: m2Quantity,
                  pricePerM2: pricePerM2,
                  totalPrice: m2Quantity * pricePerM2,
                  image: imageElement ? imageElement.src : null,
                  vat: vat,
                  isQuote: true
                });
              }
            } else {
              window.location.href = `/${country.toLowerCase()}-${locale}/checkout`;
            }
          },
          error: function(xhr, textStatus, errorThrown) {
            let actualXhr = errorThrown;
            let response = xhr;

            if(actualXhr.status === 409 && response && response.error === 'insufficient_stock') {
              let box = document.createElement("div")
              box.setAttribute("class", "box has-background-danger has-text-white")
              box.textContent = I18n.t('cart.messages.insufficient_stock', {available: response.available, requested: response.requested}) || `Insufficient stock. Available: ${response.available}, Requested: ${response.requested}`;
              box.style.position = "absolute";
              box.style.top = "40vh";
              box.style.left = "50%";
              box.style.transform = "translate(-50%, -50%)"
              box.style.width = "600px";
              box.style.maxWidth = "90vw";
              box.style.zIndex = "9999";
              let container = document.querySelector("div.container");
              if(container) {
                container.appendChild(box);
                if(typeof main !== 'undefined' && main.fadeOut) {
                  main.fadeOut(box, 4000);
                } else {
                  setTimeout(() => box.remove(), 4000);
                }
              } else {
                document.body.appendChild(box);
                setTimeout(() => box.remove(), 4000);
              }
            } else {
              console.error('Error adding item for quote:', xhr);
            }
          }
        });
      },
      error: function(data) {
        console.error('Error clearing cart for quote:', data);
      }
    });

    event.stopPropagation();
  }

  cartText(key, replacements = {}) {
    const element = this.element.querySelector('[data-cart-customization]');
    let message = element ? element.dataset[key] : '';
    Object.keys(replacements).forEach(name => {
      message = message.replace('%{' + name + '}', String(replacements[name]));
    });
    return message;
  }

  confirmCartAction(kind, item = '') {
    if(this.confirmationPending) return Promise.resolve(false);
    this.confirmationPending = true;
    const previousFocus = document.activeElement;
    const modal = document.createElement('div');
    modal.className = 'modal is-active cart-confirm-modal';
    modal.innerHTML = '<div class="modal-background"></div><div class="modal-card" role="alertdialog" aria-modal="true" aria-labelledby="cart-confirm-title" aria-describedby="cart-confirm-message"><header class="modal-card-head"><p class="modal-card-title" id="cart-confirm-title"></p><button type="button" class="delete" data-cancel></button></header><section class="modal-card-body"><p id="cart-confirm-message"></p></section><footer class="modal-card-foot"><button type="button" class="button" data-cancel></button><button type="button" class="button is-primary" data-confirm></button></footer></div>';
    modal.querySelector('#cart-confirm-title').textContent = this.cartText(kind + 'Title');
    modal.querySelector('#cart-confirm-message').textContent = this.cartText(kind + 'Message', {item: item});
    modal.querySelector('button.delete').setAttribute('aria-label', this.cartText('cancel'));
    modal.querySelector('.modal-card-foot [data-cancel]').textContent = this.cartText('cancel');
    modal.querySelector('[data-confirm]').textContent = this.cartText(kind + 'Confirm');
    document.body.appendChild(modal);
    return new Promise(resolve => {
      const finish = confirmed => {
        modal.remove();
        this.confirmationPending = false;
        if(previousFocus && document.contains(previousFocus)) previousFocus.focus();
        resolve(confirmed);
      };
      modal.querySelectorAll('[data-cancel], .modal-background').forEach(button => button.addEventListener('click', () => finish(false)));
      modal.querySelector('[data-confirm]').addEventListener('click', () => finish(true));
      modal.addEventListener('keydown', event => {
        if(event.key === 'Escape') { event.preventDefault(); finish(false); }
        if(event.key === 'Tab') {
          const buttons = Array.from(modal.querySelectorAll('button'));
          const index = buttons.indexOf(document.activeElement);
          if(event.shiftKey && index === 0) { event.preventDefault(); buttons[buttons.length - 1].focus(); }
          if(!event.shiftKey && index === buttons.length - 1) { event.preventDefault(); buttons[0].focus(); }
        }
      });
      modal.querySelector('.modal-card-foot [data-cancel]').focus();
    });
  }

  async removeFromCart(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    if(this.cartMutationPending) return;
    const row = button.closest('[data-item-name]') || button.closest('li[data-uuid]');
    const item = button.dataset.itemName || (row && (row.dataset.itemName || row.querySelector('strong').textContent.trim())) || '';
    if(await this.confirmCartAction('remove', item)) this.removeCartItem(button.dataset.uuid);
  }

  removeCartItem(uuid) {
    return this.mutateCart('/' + uuid + '/remove', 'DELETE');
  }

  async clearCart(event) {
    event.preventDefault();
    if(this.cartMutationPending || event.currentTarget.disabled) return;
    if(await this.confirmCartAction('clear')) this.mutateCart('/clear', 'DELETE');
  }

  mutateCart(path, method, payload = null, onError = null) {
    if(this.cartMutationPending) return;
    this.cartMutationPending = true;
    if(this.hasCheckoutCartNextButtonTarget) this.checkoutCartNextButtonTarget.disabled = true;
    const controls = this.hasCheckoutItemListTarget ? Array.from(this.checkoutItemListTarget.querySelectorAll('button, input')) : [];
    controls.forEach(control => control.disabled = true);
    const finish = data => {
      this.cartMutationPending = false;
      controls.forEach(control => control.disabled = false);
      if(this.hasCheckoutCartNextButtonTarget) this.checkoutCartNextButtonTarget.disabled = data ? data.items.length === 0 : this.hasCheckoutItemListTarget && !this.checkoutItemListTarget.querySelector('[data-item-name]');
    };
    Rails.ajax({
      url: '/' + this.country.toLowerCase() + '-' + this.locale + '/cart' + path,
      type: method,
      data: payload ? JSON.stringify(payload) : '',
      contentType: false,
      processData: false,
      success: data => {
        this.updateCart(data);
        finish(data);
        // Empty checkout also resets server-rendered delivery information.
        if(method === 'DELETE' && data.items.length === 0 && this.hasCheckoutItemListTarget) window.location.reload();
      },
      error: data => {
        if(onError) onError();
        finish();
        const box = document.createElement('div');
        box.className = 'notification is-danger is-light cart-error-notice';
        box.setAttribute('role', 'alert');
        box.textContent = data && data.error === 'insufficient_stock' ? I18n.t('cart.messages.insufficient_stock', {available: data.available, requested: data.requested}) : this.cartText('requestError');
        (this.hasCheckoutItemListTarget ? this.checkoutItemListTarget : this.cartMenuItemsTarget).prepend(box);
        setTimeout(() => box.remove(), 7000);
      }
    });
  }

  decreaseQuantity(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    this.changeCartQuantity(button, nextCartQuantity(button.dataset.quantity, button.dataset.step, -1));
  }

  increaseQuantity(event) {
    event.preventDefault();
    event.stopPropagation();
    const button = event.currentTarget;
    this.changeCartQuantity(button, nextCartQuantity(button.dataset.quantity, button.dataset.step, 1));
  }

  async changeCartQuantity(control, quantity) {
    const row = control.closest('[data-item-name]');
    const input = row && row.querySelector('input[data-quantity]');
    const restore = () => { if(input) input.value = input.dataset.quantity; };
    if(this.cartMutationPending || quantity === null || quantity === undefined || quantity === '' || !Number.isFinite(Number(quantity))) { restore(); return; }
    if(Number(quantity) <= 0) {
      const confirmed = await this.confirmCartAction('remove', row ? row.dataset.itemName : '');
      restore();
      if(confirmed) this.removeCartItem(control.dataset.uuid);
      return;
    }
    const normalized = normalizeCartQuantity(quantity, control.dataset.step);
    if(normalized === null || normalized <= 0) { restore(); return; }
    if(input) input.value = normalized;
    this.mutateCart('/update', 'POST', {uuid: control.dataset.uuid, quantity: normalized}, restore);
  }

  syncDeliveryTime(data) {
    const box = document.querySelector('[data-delivery-time-field]');
    if(!box) return;
    const pickup = data.fulfillment_method === 'pickup';
    box.classList.toggle('is-hidden', pickup);
    const check = box.querySelector('#checkout_delivery_time_enabled');
    const input = box.querySelector('#checkout_delivery_time');
    check.checked = !!data.delivery_time_selected;
    check.disabled = pickup || !!this.deliveryTimeSaving;
    input.value = data.delivery_time || '';
    input.disabled = pickup || !check.checked || !!this.deliveryTimeSaving;
  }

  setDeliveryTime() {
    if(this.deliveryTimeSaving) return;
    if(this.cartMutationPending) { if(this.currentCart) this.syncDeliveryTime(this.currentCart); return; }
    const check = document.querySelector('#checkout_delivery_time_enabled');
    const input = document.querySelector('#checkout_delivery_time');
    if(!check || !input) return;
    const payload = new URLSearchParams({enabled: check.checked ? '1' : '0', time: input.value}).toString();
    this.deliveryTimeSaving = true;
    this.cartMutationPending = true;
    check.disabled = true; input.disabled = true;
    const fulfillmentInputs = [...document.querySelectorAll('input[name="checkout[fulfillment_method]"]')];
    fulfillmentInputs.forEach(field => field.disabled = true);
    if(this.hasCheckoutCartNextButtonTarget) this.checkoutCartNextButtonTarget.disabled = true;
    if(this.hasCheckoutCartFinishButtonTarget) this.checkoutCartFinishButtonTarget.disabled = true;
    Rails.ajax({url: '/' + this.country.toLowerCase() + '-' + this.locale + '/cart/delivery_time', type: 'POST', data: payload,
      success: data => { this.deliveryTimeSaving = false; this.updateCart(data); document.querySelector('[data-delivery-time-error]').classList.add('is-hidden'); },
      error: () => { this.deliveryTimeSaving = false; if(this.currentCart) this.syncDeliveryTime(this.currentCart); document.querySelector('[data-delivery-time-error]').classList.remove('is-hidden'); },
      complete: () => {
        this.deliveryTimeSaving = false;
        this.cartMutationPending = false;
        fulfillmentInputs.forEach(field => field.disabled = false);
        if(this.hasCheckoutCartNextButtonTarget) this.checkoutCartNextButtonTarget.disabled = !this.checkoutItemListTarget.querySelector('[data-item-name]');
        if(this.hasCheckoutCartFinishButtonTarget) this.checkoutCartFinishButtonTarget.disabled = !document.querySelector('#terms').checked;
      }});
  }

  validateDeliveryTime() {
    if(this.deliveryTimeSaving) return false;
    const check = document.querySelector('#checkout_delivery_time_enabled');
    const input = document.querySelector('#checkout_delivery_time');
    if(!check || !input || input.disabled || !check.checked) return true;
    const valid = /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(input.value);
    document.querySelector('[data-delivery-time-error]').classList.toggle('is-hidden', valid);
    if(!valid) input.focus();
    return valid;
  }

  updateCart(data) {
    this.currentCart = data;
    this.syncDeliveryTime(data);
    document.querySelectorAll('[data-delivery-time-cost]').forEach(row => {
      row.classList.toggle('is-hidden', !data.delivery_time_selected);
      row.querySelector('[data-delivery-time-cost-value]').textContent = this.currenciesFormat(Number(data.delivery_time_surcharge || 0).toFixed(2), this.currency);
    });
    ['total_with_vat', 'total_items', 'vat', 'shipping'].forEach(key => data[key] = parseFloat(data[key]) || 0);
    data.items = data.items || [];
    if(this.hasClearCartButtonTarget) this.clearCartButtonTarget.disabled = data.items.length === 0;
    this.element.querySelectorAll('[data-fulfillment-cost-label]').forEach(label => {
      label.textContent = I18n.t(data.fulfillment_method === 'pickup' ? 'checkout.pickup' : 'checkout.shipping');
    });
    this.navbarCartItemsCounterTarget.textContent = data.count > 0 ? Math.max(1, Math.round(data.count)) : 0;
    this.navbarMobileCartItemsCounterTarget.textContent = data.count > 0 ? Math.max(1, Math.round(data.count)) : 0;
    if(data.count == 0) {
      this.navbarCartItemsCounterTarget.classList.add('is-hidden');
      this.navbarMobileCartItemsCounterTarget.classList.add('is-hidden');
      this.cartMenuCheckoutButtonTarget.classList.add('is-hidden');

      this.cartMenuItemsTarget.innerHTML = `
        <li class="cart-empty">
          <p class="has-text-grey-dark p-3">
            ${I18n.t('cart.is_empty')}
          </p>
        </li>
      `

      if(this.hasCheckoutCartNextButtonTarget) {
        this.checkoutCartNextButtonTarget.disabled = true;
      }
      if(this.hasCheckoutItemListTarget) {
        this.checkoutItemListTarget.innerHTML = `
          <p class="has-text-grey-dark p-3">
            ${I18n.t('cart.is_empty')}
          </p>
        `
      }
    } else {
      this.navbarCartItemsCounterTarget.classList.remove('is-hidden');
      this.navbarMobileCartItemsCounterTarget.classList.remove('is-hidden');
      this.cartMenuCheckoutButtonTarget.classList.remove('is-hidden');

      let div = this.cartMenuItemsTarget.querySelector("li.cart-empty");
      if(div) {
        div.remove();
      }
    }

    if(this.hasCartMenuTotalTarget) {
      this.cartMenuTotalTarget.innerHTML = this.currenciesFormat(data.total_with_vat.toFixed(2), this.currency);
    }
    if(this.hasCartMenuShippingCostTarget) {
      this.cartMenuShippingCostTarget.innerHTML = this.currenciesFormat(data.shipping.toFixed(2), this.currency);
    }
    if(this.hasCartMenuShippingLabelTarget) {
      this.cartMenuShippingLabelTarget.textContent = I18n.t(data.fulfillment_method == 'pickup' ? 'checkout.pickup' : 'cart.shipping');
    }

    if(this.hasCheckoutCartItemsCountTarget) {
      this.checkoutCartItemsCountTarget.textContent = data.count > 0 ? Math.max(1, Math.round(data.count)) : 0;
    }
    if(this.hasCheckoutTotalTarget) {
      this.checkoutTotalTargets.forEach((div, i) => {
        div.innerHTML = this.currenciesFormat(data.total_with_vat.toFixed(2), this.currency);
      });
    }
    if(this.hasCheckoutItemsTarget) {
      this.checkoutItemsTargets.forEach(target => target.textContent = this.currenciesFormat(data.total_items.toFixed(2), this.currency));
    }
    if(this.hasCheckoutVatTarget) {
      this.checkoutVatTargets.forEach((div, i) => {
        div.innerHTML = this.currenciesFormat(data.vat.toFixed(2), this.currency);
      });
    }
    let hiddenTotal = document.querySelector("input#checkout_total_with_vat");
    if(hiddenTotal) hiddenTotal.value = data.total_with_vat;
    let hiddenVat = document.querySelector("input#checkout_vat");
    if(hiddenVat) hiddenVat.value = data.vat;
    let hiddenTotalNet = document.querySelector("input#checkout_total");
    if(hiddenTotalNet) hiddenTotalNet.value = data.total;
    if(this.hasCheckoutShippingCostTarget) {
      this.checkoutShippingCostTargets.forEach((target, i) => {
        target.innerHTML = this.currenciesFormat(Number(data.shipping_base == null ? data.shipping : data.shipping_base).toFixed(2), this.currency);
      });
    }
    this.element.querySelectorAll('[data-cart-cost-charges]').forEach(row => {
      row.classList.toggle('is-hidden', !data.charges);
      row.querySelector('[data-cart-cost-charges-label]').textContent = data.charges ? data.charges.description : '';
      row.querySelector('[data-cart-cost-charges-value]').textContent = data.charges ? this.currenciesFormat(Number(data.charges.charges).toFixed(2), this.currency) : '';
    });
    this.element.querySelectorAll('[data-cart-voucher-costs]').forEach(body => {
      body.textContent = '';
      (data.vouchers || []).forEach(voucher => {
        const row = document.createElement('tr');
        const label = document.createElement('td');
        label.textContent = this.cartText('voucher') + ' ' + voucher.code;
        const value = document.createElement('td');
        value.className = 'has-text-right';
        value.textContent = this.currenciesFormat((-Number(voucher.amount || voucher.discount || 0)).toFixed(2), this.currency);
        row.append(label, value);
        body.appendChild(row);
      });
    });

    data.total_with_vat = parseFloat(data.total_with_vat) || 0;
    data.total_items = parseFloat(data.total_items) || 0;
    data.vat = parseFloat(data.vat) || 0;
    data.shipping = parseFloat(data.shipping) || 0;
    if(data.items) {
      data.items.forEach(item => {
        item.total = parseFloat(item.total) || 0;
        item.quantity = parseFloat(item.quantity) || 0;
      });
    }

    this.removeDeletedItems(data.items);

    const updates = [];

    data.items.forEach((item, i) => {
      if(!item || !item.uuid || item.total === undefined || item.quantity === undefined) {
        console.warn('Invalid item data:', item);
        return;
      }

      const formattedTotal = this.currenciesFormat(item.total.toFixed(2), this.currency);

      let div = this.cartMenuItemsTarget.querySelector(`li[data-uuid="${item.uuid}"]`);
      if(div) {
        updates.push(() => {
          let sml = div.querySelector('small');
          if(sml) {
            sml.innerHTML = `${I18n.t('cart.quantity')}: ${item.quantity}`;
          }
          sml = div.querySelector('small.pos-total');
          if(sml) {
            sml.innerHTML = formattedTotal;
          }
        });
      } else {
        updates.push(() => {
          let details = [];
          let span = '';
          if(item.color) {
            details.push(`${I18n.t('item.color')}: ${item.color}`);
          }
          if(item.size) {
            details.push(`${I18n.t('item.size')}: ${item.size}`);
          }
          if(details.length > 0) {
            span = `<span class="is-size-7">${details.join(', ')}</span><br>`;
          }

          let cartItem = document.createElement('li');
          cartItem.classList.add('mb-3');
          cartItem.setAttribute("data-uuid", item.uuid);
          cartItem.innerHTML = `
              <article class="media">
                <figure class="media-left">
                  <p class="image is-64x64 is-clipped">
                    <img src="${item.image || ''}" alt="${item.name}" class="is-overlay">
                  </p>
                </figure>
                <div class="media-content pt-1">
                  <div class="content">
                    <p>
                      <strong>${item.name}
                        <span class="is-pulled-right">
                          <button type="button" class="button is-white is-small" data-uuid="${item.uuid}" data-action="click->cart#removeFromCart">
                            <i class="fas fa-times has-text-danger"></i>
                          </button>
                        </span>
                      </strong>
                      <br>
                      ${span}
                      <small>${I18n.t('cart.quantity')}: ${item.quantity}</small>
                      <small class="is-pulled-right has-text-weight-semibold pos-total">
                        ${formattedTotal}
                      </small>
                    </p>
                </div>
              </div>
            </article>
          `
          this.cartMenuItemsTarget.appendChild(cartItem);
        });
      }

      if(this.hasCheckoutCartItemsTarget) {
        updates.push(() => {
          div = this.checkoutCartItemsTarget.querySelector(`[data-uuid="${item.uuid}"]`);
          if(!div) return;

          let inp = div.querySelector('input');
          if(inp) {
            inp.value = item.quantity;
            inp.dataset.quantity = item.quantity;
            inp.dataset.step = item.quantity_step || 1;
          }

          let decreaseBtn = div.querySelector('button.decrease');
          if(decreaseBtn) {
            decreaseBtn.setAttribute("data-quantity", item.quantity);
            decreaseBtn.dataset.step = item.quantity_step || 1;
          }

          let increaseBtn = div.querySelector('button.increase');
          if(increaseBtn) {
            increaseBtn.setAttribute("data-quantity", item.quantity);
            increaseBtn.dataset.step = item.quantity_step || 1;
          }

          this.updateCartonLabel(div, item);
          let div_total = div.querySelectorAll("div.price-total");
          div_total.forEach((dt, i) => {
            dt.textContent = formattedTotal;
          });
        });

        updates.push(() => {
          div = this.checkoutSummaryCartItemsTarget?.querySelector(`[data-uuid="${item.uuid}"]`);
          if(!div) return;

          this.updateCartonLabel(div, item);
          let sum_total = div.querySelector("span.is-pulled-right");
          if(sum_total) {
            sum_total.textContent = formattedTotal;
          }
          let sum_quantity = div.querySelector("span.quantity");
          if(sum_quantity) {
            sum_quantity.textContent = item.quantity;
          }
        });
      }
    });

    requestAnimationFrame(() => {
      updates.forEach(update => {
        try {
          update();
        } catch(error) {
          console.error('Cart update error:', error);
        }
      });
    });
  }

  updateCartonLabel(row, item) {
    const label = row.querySelector('[data-carton-label]');
    if(!label) return;
    const cartons = item.carton_size ? cartonCount(item.quantity, item.carton_size) : null;
    label.classList.toggle('is-hidden', !cartons);
    const compact = label.dataset.cartonCompact === 'true';
    if(cartons) label.textContent = (compact ? ' · ' : '') + this.cartText(compact ? (cartons === 1 ? 'cartonCount' : 'cartonsCount') : (cartons === 1 ? 'cartonQuantity' : 'cartonsQuantity'), {
      count: new Intl.NumberFormat(this.locale, {maximumFractionDigits: 4}).format(cartons),
      quantity: new Intl.NumberFormat(this.locale, {maximumFractionDigits: 4}).format(item.quantity)
    });
  }

  removeDeletedItems(currentItems) {
    const currentUuids = new Set(currentItems.map(item => item.uuid));

    const cartMenuItems = this.cartMenuItemsTarget.querySelectorAll('li[data-uuid]');
    cartMenuItems.forEach(element => {
      const uuid = element.getAttribute('data-uuid');
      if (uuid && !currentUuids.has(uuid)) {
        element.remove();
      }
    });

    if(this.hasCheckoutCartItemsTarget) {
      const checkoutItems = this.checkoutCartItemsTarget.querySelectorAll('[data-uuid]');
      checkoutItems.forEach(element => {
        const uuid = element.getAttribute('data-uuid');
        if (uuid && !currentUuids.has(uuid)) {
          element.remove();
        }
      });
    }

    if(this.hasCheckoutSummaryCartItemsTarget) {
      const summaryItems = this.checkoutSummaryCartItemsTarget.querySelectorAll('[data-uuid]');
      summaryItems.forEach(element => {
        const uuid = element.getAttribute('data-uuid');
        if (uuid && !currentUuids.has(uuid)) {
          element.remove();
        }
      });
    }
  }

  validateDeliveryDate() {
    const field = document.querySelector('#checkout_delivery_date');
    if(!field) return true;

    const tooEarly = !!field.value && field.value < field.min;
    const day = field.value ? new Date(`${field.value}T12:00:00`).getDay() : null;
    const weekend = field.dataset.allowWeekends !== 'true' && (day === 0 || day === 6);
    field.classList.toggle('is-danger', tooEarly || weekend);
    field.setAttribute('aria-invalid', String(tooEarly || weekend));
    document.querySelector('.delivery-date-error').classList.toggle('is-hidden', !tooEarly);
    document.querySelector('.delivery-date-weekend-error').classList.toggle('is-hidden', !weekend);
    return !tooEarly && !weekend;
  }

  nextStep() {
    if(this.currentStep == this.steps) {
      return;
    } else {

      if(this.cartMutationPending || this.deliveryTimeSaving) return;
      if(this.currentStep === 1 && (!this.hasCheckoutItemListTarget || !this.checkoutItemListTarget.querySelector('[data-item-name]'))) return;
      if(this.currentStep == 1 && (!this.validateDeliveryDate() || !this.validateDeliveryTime())) return;

      if(this.currentStep == 2) {
        let customer = document.querySelector("#data_customer_company");

        let firstname = document.querySelector("#checkout_firstname");
        let lastname = document.querySelector("#checkout_lastname");
        let email = document.querySelector("#checkout_email");
        let email_helper = document.querySelector(".help.email");
        let phone = document.querySelector("#checkout_phone");
        let cem = document.querySelector("#data_cem");
        let cem_helper = document.querySelector(".help.cem");

        let name = document.querySelector("#checkout_name");
        let street = document.querySelector("#checkout_street");
        let house_number = document.querySelector("#checkout_house_number");
        let zip = document.querySelector("#checkout_zip");
        let location = document.querySelector("#checkout_location");
        let country = document.querySelector("#checkout_country");

        let error = false;
        if(firstname.value.trim() == '') {
          firstname.classList.add('is-danger');
          error = true;
        } else {
          firstname.classList.remove('is-danger');
        }
        if(lastname.value.trim() == '') {
          lastname.classList.add('is-danger');
          error = true;
        } else {
          lastname.classList.remove('is-danger');
        }
        if(email.value.trim() == '' || !this.validateEmail(email.value.trim())) {
          email.classList.add('is-danger');
          email_helper.classList.remove("is-hidden");
          error = true;
        } else {
          email.classList.remove('is-danger');
          email_helper.classList.add("is-hidden");
        }

        if(phone.getAttribute('required')) {
          if(phone.value.trim() == '' || phone.value.length < 6) {
            phone.classList.add('is-danger');
            error = true;
          } else {
            phone.classList.remove('is-danger');
          }
        }

        if(cem) {
          if(cem.value.trim() != '' && !this.validateEmail(email.value.trim())) {
            cem.classList.add('is-danger');
            cem_helper.classList.remove("is-hidden");
            error = true;
          } else {
            cem.classList.remove('is-danger');
            cem_helper.classList.add("is-hidden");
          }
        }

        const company = document.querySelector('#checkout_company');
        if(customer.checked && !company.value.trim()) {
          company.classList.add('is-danger');
          error = true;
        } else {
          company.classList.remove('is-danger');
        }
        if(customer.checked || name.value.trim() == '') {
          name.value = `${firstname.value.trim()} ${lastname.value.trim()}`.trim()
        }
        if(street.value.trim() == '') {
          street.classList.add('is-danger');
          error = true;
        } else {
          street.classList.remove('is-danger');
        }
        if(house_number.value.trim() == '') {
          house_number.classList.add('is-danger');
          error = true;
        } else {
          house_number.classList.remove('is-danger');
        }
        if(zip.value.trim() == '') {
          zip.classList.add('is-danger');
          error = true;
        } else {
          zip.classList.remove('is-danger');
        }
        if(location.value.trim() == '') {
          location.classList.add('is-danger');
          error = true;
        } else {
          location.classList.remove('is-danger');
        }
        if(country.value.trim() == '') {
          country.parentNode.classList.add('is-danger');
          error = true;
        } else {
          country.parentNode.classList.remove('is-danger');
        }

        if(email.value.trim() == '' || !this.validateEmail(email.value.trim())) {
          email.classList.add('is-danger');
          email_helper.classList.remove("is-hidden");
          error = true;
        } else {
          email.classList.remove('is-danger');
          email_helper.classList.add("is-hidden");
        }

        /*
        if(customer.checked) {
          let taxid = document.querySelector("#data_taxid");
          if(taxid.value.trim() == '') {
            taxid.classList.add('is-danger');
            error = true;
          } else {
            taxid.classList.remove('is-danger');
          }

          let fiscal_code = document.querySelector("#data_fiscal_code");
          if(fiscal_code.value.trim() == '') {
            if(taxid.value.trim() != '') {
              fiscal_code.value = taxid.value;
            } else {
              fiscal_code.classList.add('is-danger');
              error = true;
            }
          } else {
            fiscal_code.classList.remove('is-danger');
          }
        }
        */

        if(this.invoiceDirectionToggleTarget.checked) {
          let invoice_name = document.querySelector("#invoice_name");
          let invoice_street = document.querySelector("#invoice_street");
          let invoice_house_number = document.querySelector("#invoice_house_number");
          let invoice_zip = document.querySelector("#invoice_zip");
          let invoice_location = document.querySelector("#invoice_location");

          if(invoice_name.value.trim() == '') {
            invoice_name.classList.add('is-danger');
            error = true;
          } else {
            invoice_name.classList.remove('is-danger');
          }
          if(invoice_street.value.trim() == '') {
            invoice_street.classList.add('is-danger');
            error = true;
          } else {
            invoice_street.classList.remove('is-danger');
          }
          if(invoice_house_number.value.trim() == '') {
            invoice_house_number.classList.add('is-danger');
            error = true;
          } else {
            invoice_house_number.classList.remove('is-danger');
          }
          if(invoice_zip.value.trim() == '') {
            invoice_zip.classList.add('is-danger');
            error = true;
          } else {
            invoice_zip.classList.remove('is-danger');
          }
          if(invoice_location.value.trim() == '') {
            invoice_location.classList.add('is-danger');
            error = true;
          } else {
            invoice_location.classList.remove('is-danger');
          }
        }

        if(error) {
          return;
        }
      }

      this.currentStep++;
      if(this.currentStep === this.steps) this.timelineUnlocked = true;

      if(this.currentStep > 1) {
        let btnBack = document.querySelector('#btn-back');
        btnBack.classList.remove('is-static');
      }

      this.refreshView();
    }
  }

  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  goToStep(event) {
    event.preventDefault();
    const desiredStep = Number(event.currentTarget.dataset.step);
    if(!this.timelineUnlocked || this.cartMutationPending || desiredStep < 1 || desiredStep > this.steps) return;
    if(desiredStep <= this.currentStep) {
      this.currentStep = desiredStep;
      this.refreshView();
    } else {
      while(this.currentStep < desiredStep) {
        const previousStep = this.currentStep;
        this.nextStep();
        if(this.currentStep === previousStep) break;
      }
    }
    const activePanel = [this.checkoutCartItemsTarget, this.checkoutShippingTarget, this.checkoutPaymentTarget, this.checkoutConfirmationTarget][this.currentStep - 1];
    const title = activePanel.querySelector('h2');
    if(title) { title.setAttribute('tabindex', '-1'); title.focus({preventScroll: true}); }
  }

  previousStep() {
    if(this.currentStep == 1) {
      return;
    }

    this.currentStep--;

    let currentState = document.querySelector(".steps").children[this.currentStep-1];
    currentState.classList.add('is-active');

    this.refreshView();
  }

  refreshView() {
    let steps = document.querySelector(".steps").children;
    for(var i = 0; i<steps.length; i++) {
      const button = steps[i].querySelector('.cart-step-link');
      if(button) {
        button.disabled = !this.timelineUnlocked;
        if(i + 1 === this.currentStep) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      }
      steps[i].classList.remove('is-active');
      if(i+1 == this.currentStep) {
        steps[i].classList.add('is-active');
      }
    }

    let btnNext = document.querySelector('#btn-next');
    let btnFinish = document.querySelector('#btn-confirm');

    document.querySelector('#btn-back').classList.toggle('is-static', this.currentStep <= 1);

    if(this.currentStep == this.steps) {
      btnNext.classList.add('is-hidden');
      btnFinish.classList.remove('is-hidden');
    } else {
      btnFinish.classList.add('is-hidden');
      btnNext.classList.remove('is-hidden');
    }

    this.checkoutCartItemsTarget.classList.add('is-hidden');
    this.checkoutShippingTarget.classList.add('is-hidden');
    this.checkoutPaymentTarget.classList.add('is-hidden');
    this.checkoutConfirmationTarget.classList.add('is-hidden');

    let company = this.removeTags(document.querySelector("#checkout_company").value);
    let firstname = this.removeTags(document.querySelector("#checkout_firstname").value);
    let lastname = this.removeTags(document.querySelector("#checkout_lastname").value);
    let email = this.removeTags(document.querySelector("#checkout_email").value);

    let address = this.shipping_addressTarget;
    let name = this.removeTags(document.querySelector("#checkout_name").value);
    let street = this.removeTags(document.querySelector("#checkout_street").value);
    let house_number = this.removeTags(document.querySelector("#checkout_house_number").value);
    let zip = this.removeTags(document.querySelector("#checkout_zip").value);
    let location = this.removeTags(document.querySelector("#checkout_location").value);
    let state = this.removeTags(document.querySelector("#checkout_state").value);
    let country = this.removeTags(document.querySelector("#checkout_country").value);

    address.innerHTML = '';
    const recipient = deliveryRecipient({type: document.querySelector('#data_customer_company').checked ? 'company' : 'private',
      company, name, fullName: `${firstname} ${lastname}`});
    if(!document.querySelector('#data_customer_company').checked) {
      address.innerHTML += `<b>${firstname} ${lastname}</b><br>`;
    }
    address.innerHTML += email;
    address.innerHTML += '<br><br>';
    address.innerHTML += '<b>'+recipient.name+'</b><br>';
    address.innerHTML += street+' '+house_number+'<br>'+zip+' '+location;
    if(state && state != '') {
      address.innerHTML += '<br>'+state;
    }
    if(country && country != '') {
      address.innerHTML += '<br>'+countries.getName(country, this.locale);
    }
    if(recipient.reference) {
      const label = document.querySelector('[data-delivery-reference-label]').dataset.deliveryReferenceLabel;
      address.innerHTML += '<br><br><b>'+label+':</b> '+recipient.reference;
    }

    let fulfillmentMethod = document.querySelector('[name="checkout[fulfillment_method]"]:checked');
    let pickupNotice = document.querySelector('.pickup-location-notice');
    if(fulfillmentMethod && fulfillmentMethod.value == 'pickup' && pickupNotice) {
      address.innerHTML += `<br><br><b>${I18n.t('checkout.pickup')}</b><br>${this.removeTags(pickupNotice.dataset.pickupLocation)}`;
    }

    let deliveryDate = document.querySelector('#checkout_delivery_date');
    if(deliveryDate && deliveryDate.value) {
      address.innerHTML += `<br><br><b>${I18n.t('checkout.delivery_date')}:</b> ${this.removeTags(deliveryDate.value)}`;
    }

    const deliveryTime = document.querySelector('#checkout_delivery_time');
    const timeCheck = document.querySelector('#checkout_delivery_time_enabled');
    if(deliveryTime && timeCheck && timeCheck.checked && !deliveryTime.disabled && deliveryTime.value) {
      const label = this.element.querySelector('[data-delivery-time-label]').dataset.deliveryTimeLabel;
      address.innerHTML += '<br><b>' + label + ':</b> ' + this.removeTags(deliveryTime.value);
    }

    if(this.invoiceDirectionToggleTarget.checked) {
      let invoice_address = document.querySelector("#invoice_address");
      let invoice_company_name = '';
      if(document.querySelector("#invoice_company_name")) {
        invoice_company_name = this.removeTags(document.querySelector("#invoice_company_name").value);
      }
      let invoice_name = this.removeTags(document.querySelector("#invoice_name").value);
      let invoice_street = this.removeTags(document.querySelector("#invoice_street").value);
      let invoice_house_number = this.removeTags(document.querySelector("#invoice_house_number").value);
      let invoice_zip = this.removeTags(document.querySelector("#invoice_zip").value);
      let invoice_location = this.removeTags(document.querySelector("#invoice_location").value);
      let invoice_state = this.removeTags(document.querySelector("#invoice_state").value);
      let invoice_country = this.removeTags(document.querySelector("#invoice_country").value);

      invoice_address.innerHTML = '';
      if(invoice_company_name && invoice_company_name != '') {
        invoice_address.innerHTML += '<b>'+invoice_company_name+'</b><br>';
      }
      invoice_address.innerHTML += '<b>'+invoice_name+'</b><br>';
      invoice_address.innerHTML += invoice_street+' '+invoice_house_number+'<br>'+invoice_zip+' '+invoice_location;
      if(invoice_state && invoice_state != '') {
        invoice_address.innerHTML += '<br>'+invoice_state;
      }
      if(invoice_country && invoice_country != '') {
        invoice_address.innerHTML += '<br>'+countries.getName(invoice_country, this.locale);
      }

      invoice_address.classList.remove("is-hidden");
      this.invoice_direction_headerTarget.classList.remove("is-hidden");
    } else {
      invoice_address.classList.add("is-hidden");
      this.invoice_direction_headerTarget.classList.add("is-hidden");
    }

    switch(this.currentStep) {
      case 1:
        this.checkoutCartItemsTarget.classList.remove('is-hidden');
        break;
      case 2:
        this.checkoutShippingTarget.classList.remove('is-hidden');
        break;
      case 3:
        this.checkoutPaymentTarget.classList.remove('is-hidden');
        break;
      case 4:
        this.checkoutConfirmationTarget.classList.remove('is-hidden');
        break;
    }
  }

  setAddress() {
    let addr = event.target.dataset.address;

    let name = event.target.dataset.name;
    let street = event.target.dataset.street;
    let house_number = event.target.dataset.houseNumber;
    let zip = event.target.dataset.zip;
    let location = event.target.dataset.location;
    let state = event.target.dataset.state;
    let country = event.target.dataset.country;

    document.querySelector("#checkout_name").value = name;
    document.querySelector("#checkout_street").value = street;
    document.querySelector("#checkout_house_number").value = house_number || '';
    document.querySelector("#checkout_zip").value = zip;
    document.querySelector("#checkout_location").value = location;
    document.querySelector("#checkout_state").value = state;
    document.querySelector("#checkout_country").value = country;

    document.querySelector("#checkout_country").dispatchEvent(new Event('change'));
  }

  setInvoiceAddress() {
    let addr = event.target.dataset.address;

    let name = event.target.dataset.name;
    let street = event.target.dataset.street;
    let house_number = event.target.dataset.houseNumber;
    let zip = event.target.dataset.zip;
    let location = event.target.dataset.location;
    let state = event.target.dataset.state;
    let country = event.target.dataset.country;

    document.querySelector("#invoice_name").value = name;
    document.querySelector("#invoice_street").value = street;
    document.querySelector("#invoice_house_number").value = house_number || '';
    document.querySelector("#invoice_zip").value = zip;
    document.querySelector("#invoice_location").value = location;
    document.querySelector("#invoice_state").value = state;
    document.querySelector("#invoice_country").value = country;
  }

  toggleTermCheck() {
    var btn = document.querySelector('#btn-confirm');
    if(event.target.checked) {
      btn.removeAttribute('disabled', 'true');
    } else {
      btn.setAttribute('disabled', 'true');
    }
  }

  toggleFinishButton() {
    var btn = document.querySelector('#btn-confirm');
    var btnBack = document.querySelector('#btn-back');
    var icon = btn.querySelector("svg");
    if(btn.classList.contains('is-static')) {
      btn.classList.remove('is-warning');
      btn.classList.add('is-primary');
      btn.classList.add('is-static');
      btnBack.classList.remove('is-static');

      icon.classList.remove("fa-spinner","fa-pulse");
      icon.classList.add("fa-check");
    } else {
      btn.classList.add('is-static');
      btnBack.classList.add('is-static');
      btn.classList.remove('is-primary');
      btn.classList.add('is-warning');

      icon.classList.remove("fa-check");
      icon.classList.add("fa-spinner","fa-pulse");

      let radio = document.querySelector('[name="checkout[payment_method]"]:checked')
      if(radio.value != 'advance') {
        var busy = document.querySelector(".modal");

        let sumup;
        try {
          sumup = SumUpCard;
        } catch {

        }

        if(sumup && radio.value != 'paypal') {
          busy.querySelector(".modal-content").classList.add("card")
          busy.querySelector(".modal-content").innerHTML = `
            <div id="sumup-notification" class="notification is-hidden mb-2">
            </div>
            <div id="sumup-widget">
            </div>
            <div class="is-flex is-justify-content-center pt-2">
              <a id="btnSumpUpCancel" href="/${I18n.locale}/checkout/payment/cancelled/" class="button is-small is-text">
                ${I18n.t("checkout.cancel")}
              </a>
            </div>
          `;
        }
        busy.classList.add('is-active');
      }
    }
  }

  checkQuantities() {
    event.stopPropagation();

    if(event.target.dataset.step) {
      let that = this;
      let uuid = event.target.dataset.uuid;
      let quantity = parseFloat(event.target.value);
      let step = parseFloat(event.target.dataset.step);
      try {
        let d = Math.ceil(quantity / step);
        quantity = d * step;
        event.target.value = quantity

        if(uuid != '' && quantity != '') {
          Rails.ajax({
            url: `/${this.country.toLowerCase()}-${this.locale}/cart/update`,
            type: "POST",
            data: `uuid=${uuid}&quantity=${quantity}`,
            success: function(data) {
              that.updateCart(data);
            },
            error: function(xhr, textStatus, errorThrown) {
              let actualXhr = errorThrown;
              let response = xhr;

              if(actualXhr.status === 409 && response && response.error === 'insufficient_stock') {
                let box = document.createElement("div")
                box.setAttribute("class", "box has-background-danger has-text-white")
                box.textContent = I18n.t('cart.messages.insufficient_stock', {available: response.available, requested: response.requested}) || `Insufficient stock. Available: ${response.available}, Requested: ${response.requested}`;
                box.style.position = "absolute";
                box.style.top = "40vh";
                box.style.left = "50%";
                box.style.transform = "translate(-50%, -50%)"
                box.style.width = "600px";
                box.style.maxWidth = "90vw";
                box.style.zIndex = "9999";
                let container = document.querySelector("div.container");
                if(container) {
                  container.appendChild(box);
                  if(typeof main !== 'undefined' && main.fadeOut) {
                    main.fadeOut(box, 4000);
                  } else {
                    setTimeout(() => box.remove(), 4000);
                  }
                } else {
                  document.body.appendChild(box);
                  setTimeout(() => box.remove(), 4000);
                }
              }
            }
          });
        }
      } catch {

      }
    }
  }

  updateQuantity(event) {
    event.stopPropagation();
    const input = event.currentTarget;
    const value = input.value.trim().replace(',', '.');
    if(value === '' || !Number.isFinite(Number(value))) {
      input.value = input.dataset.quantity;
      return;
    }
    this.changeCartQuantity(input, Number(value));
  }

  toggleCustomerType() {
    if(event.target.value) {
      if(event.target.value == 'company') {
        this.privateDataTarget.classList.add('is-hidden');
        this.companyDataTarget.classList.remove('is-hidden');
        if(this.hasCompanyInvoiceDataTarget) {
          this.companyInvoiceDataTarget.classList.remove('is-hidden');
        }
      } else {
        this.companyDataTarget.classList.add('is-hidden');
        this.privateDataTarget.classList.remove('is-hidden');
        if(this.hasCompanyInvoiceDataTarget) {
          this.companyInvoiceDataTarget.classList.add('is-hidden');
        }
      }
    }
  }

  toggleInvoiceDirection() {
    if(event.target.type) {
      if(event.target.checked) {
        this.invoice_directionTarget.classList.remove('is-hidden');
      } else {
        this.invoice_directionTarget.classList.add('is-hidden');
      }
    }
  }

  setPaymentMethod() {
    let that = this;
    let radio = event.target;


    switch (radio.value) {
      case "twint":
        this.checkout_paymentTarget.innerHTML = `
          <div class="is-flex is-align-items-center">
            <div class="checkout-twint-logo has-text-centered is-flex mr-2">
              <img src="/images/twint_logo_h_pos_bg.png" class="checkout-twint-logo m-auto">
            </div>
            ${I18n.t('checkout.twint')}
          </div>
        `;
        break;
      case "postfinance":
        this.checkout_paymentTarget.innerHTML = `
          <div class="is-flex is-align-items-center">
            <div class="checkout-postfinance-logo has-text-centered is-flex mr-2">
              <img src="/images/postfinance.png" class="checkout-postfinance-logo m-auto">
            </div>
            ${I18n.t('checkout.postfinance')}
          </div>
        `;
        break;
      default:
        var span = radio.parentNode.querySelector('span');
        this.checkout_paymentTarget.innerHTML = span.innerHTML;
    }

    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/checkout/payment/set/${radio.value}`,
      type: "POST",
      data: null,
      success: function(data) {
        if(radio.dataset.chargesType && radio.dataset.chargesAmount) {
          that.applyCharges(radio.dataset.chargesAmount, radio.dataset.chargesType, radio.dataset.chargesDescription)
        } else {
          that.removeCharges()
        }
      },
      error: function(data) {}
    });
  }

  switchCountry() {
    let country = event.target.dataset.country;
    let locale = event.target.dataset.locale;
    if(event.target.dataset.locale) {
      locale = event.target.dataset.locale;
    }
    let title = I18n.t('cart.messages.country_change');
    let content = I18n.t('cart.messages.country_clear_cart', {country: I18n.t(`countries.${country}`)});

    let modal = Modal.createModal(title, content, [{label: I18n.t('btn.cancel'), event: 'cancel', classes: ''}, {label: I18n.t('btn.accept'), event: 'success', classes: 'is-success'}]);
    modal.openModal();

    modal.addEventListener('success', () => {
      Rails.ajax({
        url: '/set_country',
        type: "POST",
        data: `country=${country}&current_path=${encodeURIComponent(window.location.pathname)}`,
        success: function(data) {
          if (data.success && data.redirect_url) {
            window.location.href = data.redirect_url;
          } else {
            window.location.reload();
          }
        },
        error: function(data) {
          window.location.reload();
        }
      });
    })
  }

  addVoucher() {
    let that = this;
    if(this.vouchercodeTarget.value != '') {
      Rails.ajax({
        url: `/${this.country.toLowerCase()}-${this.locale}/cart/voucher`,
        type: "POST",
        data: `code=${this.vouchercodeTarget.value}`,
        success: function(data) {
          location.reload();
        },
        error: function(data) {

          switch(data.error) {
            case 'purchase':
              var alert = document.querySelector(".notification.voucher");
              alert.innerHTML = `<i class='fa fa-exclamation-circle fa-lg'></i> ${I18n.t('voucher.error.purchase', {purchase: `${data.value} ${that.currency}`})}`;
              alert.classList.remove('is-hidden');
              main.fadeOut(alert, 8000);
              break
            default:
              var alert = document.querySelector(".notification.voucher");
              alert.innerHTML = `<i class='fa fa-exclamation-circle fa-lg'></i> ${I18n.t('voucher.error.invalid')}`;
              alert.classList.remove('is-hidden');
              main.fadeOut(alert, 8000);
              break
          }
        }
      });
    }
  }

  removeVoucher(event) {
    const button = event.currentTarget;
    if(button.dataset.code && button.dataset.uuid) {
      Rails.ajax({
        url: `/${this.country.toLowerCase()}-${this.locale}/cart/voucher`,
        type: "DELETE",
        data: new URLSearchParams({code: button.dataset.code, uuid: button.dataset.uuid}).toString(),
        success: function(data) {
          location.reload();
        },
        error: function(data) {
          location.reload();
        }
      });
    }
  }

  applyCharges(amount, type, description) {
    let that = this;
    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/checkout/charges`,
      type: "POST",
      data: JSON.stringify({type: type, amount: amount, description: description}),
      contentType: false,
      processData: false,
      success: function(data) {
        that.updateCart(data);
        that.checkoutChargesTarget.classList.remove('is-hidden');
      },
      error: function(data) {
      }
    });
  }

  removeCharges() {
    let that = this;
    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/checkout/charges`,
      type: "DELETE",
      data: null,
      success: function(data) {
        that.checkoutChargesTarget.classList.add('is-hidden');
        that.updateCart(data);
      },
      error: function(data) {
      }
    });
  }

  setShippingCountry() {
    let that = this;
    let shippingCountry = event.target.value;
    console.log('setShippingCountry called with:', shippingCountry);
    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/cart/shipping_country`,
      type: "POST",
      data: `shipping_country=${shippingCountry}`,
      success: function(data) {
        that.updateCart(data);
      },
      error: function(data) {
        console.error('setShippingCountry error:', data);
      }
    });
  }

  setFulfillmentMethod(event) {
    let that = this;
    let fulfillmentMethod = event.target.value;
    const inputs = [...document.querySelectorAll('input[name="checkout[fulfillment_method]"]')];
    if(this.cartMutationPending) {
      inputs.forEach(input => input.checked = input.value === (this.currentCart?.fulfillment_method || 'delivery'));
      return;
    }
    this.cartMutationPending = true;
    this.deliveryTimeSaving = true;
    inputs.forEach(input => input.disabled = true);
    document.querySelectorAll('#checkout_delivery_time, #checkout_delivery_time_enabled').forEach(input => input.disabled = true);
    Rails.ajax({
      url: `/${this.country.toLowerCase()}-${this.locale}/cart/fulfillment_method`,
      type: "POST",
      data: `fulfillment_method=${encodeURIComponent(fulfillmentMethod)}`,
      success: function(data) {
        that.deliveryTimeSaving = false;
        that.updateCart(data);
        document.querySelectorAll('[data-fulfillment-cost-label]').forEach((label) => {
          label.textContent = I18n.t(fulfillmentMethod == 'pickup' ? 'checkout.pickup' : 'checkout.shipping');
        });
        let pickupNotice = document.querySelector('.pickup-location-notice');
        if(pickupNotice) pickupNotice.classList.toggle('is-hidden', fulfillmentMethod != 'pickup');
        that.refreshView();
      },
      error: function() {
        location.reload();
      },
      complete: function() {
        that.cartMutationPending = false;
        that.deliveryTimeSaving = false;
        inputs.forEach(input => input.disabled = false);
        if(that.currentCart) that.syncDeliveryTime(that.currentCart);
      }
    });
  }

  signin() {
    this.signinModalTarget.classList.add("is-active");

    this.signinModalTarget.classList.remove("is-hidden");
    setTimeout(() => {
      this.signinModalTarget.querySelector("#customer_email").focus();
    }, 250)
  }

  closeSignin() {
    this.signinModalTarget.classList.remove("is-active")
    this.signinModalTarget.querySelectorAll("input").forEach((inp, i) => {
      inp.value = ""
    });
  }
}
